import { connectSearchBox } from 'react-instantsearch-core';
import VoiceSearch from '../components/VoiceSearch';
export default connectSearchBox(VoiceSearch);


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-dom/dist/es/widgets/VoiceSearch.js
// module id = 1039
// module chunks = 0 1 2 3 4 5 6 7 8